import { createAsyncThunk } from '@reduxjs/toolkit';

import { IResourceFile } from '.';
import { AdminApiPaths, UserApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';

export interface IBrowseResources {
  resourceKey: string;
}

interface IReportResources {
  subTopicId: string;
  userId: string;
  pageNo?: string;
  reason: string;
  questionId?: string;
}

const ResourceBrowseApiDataProvider = new APIDataProvider<IResourceFile>();

export const adminBrowseResources = createAsyncThunk(
  'resources/browse',
  async (data: IBrowseResources) => {
    const path = `${AdminApiPaths.resources}/browse?resourceKey=${data.resourceKey}`;
    const response = await ResourceBrowseApiDataProvider.get(path);
    return response.data as {
      offset: number;
      limit: number;
      totalDocs: number;
      docs: Array<IResourceFile>;
    };
  }
);

export const reportResources = createAsyncThunk(
  'resources/report',
  async (data: IReportResources) => {
    const response = await ResourceBrowseApiDataProvider.create(
      UserApiPaths.report,
      data
    );
    return response.data;
  }
);
